<template>
  <div>
    <div class='top'>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <div class='h-inputLit col-sm-6'>
            <ejs-textbox ></ejs-textbox>
          </div>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <ejs-grid ref='srcGrid' :dataSource='srcDataSource' :commandClick='onClickLog'>
            <e-columns>
              <e-column type='checkbox' width='50' textAlign='center'></e-column>
              <e-column field='deviceName' headerText='设备名称' width='70'></e-column>
              <e-column field='runVersion' headerText='运行版本' width='90' textAlign='Middle'></e-column>
              <e-column field='storeVersion' headerText='存储版本' width='90' textAlign='Middle'></e-column>
              <e-column field='localVersion' headerText='本地版本' width='90' textAlign='Middle'></e-column>
              <e-column field='upgradeTime' headerText='上次升级时间' width='90' textAlign='Middle'></e-column>
              <e-column field='oper' headerText='同步操作' width='90' textAlign='Middle'></e-column>
              <e-column headerText='日志' width='90' textAlign='Middle' :commands='commandsAdd'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
    <div class='middle'>
      <ejs-button @click.native='srcToDes'>{{buttonText}}</ejs-button>
    </div>
    <div class='down'>
      <ejs-grid ref='desGrid' :dataSource='desDataSource' :commandClick='onClickDel'>
        <e-columns>
          <e-column headerText='操作' width='90' textAlign='Middle' :commands='commandsDel'></e-column>
          <e-column field='deviceName' headerText='设备名称' width='70'></e-column>
          <e-column field='runVersion' headerText='运行版本' width='200' textAlign='Middle'></e-column>
          <e-column field='storeVersion' headerText='存储版本' width='90' textAlign='Middle'></e-column>
          <e-column field='localVersion' headerText='本地版本' width='90' textAlign='Middle'></e-column>
        </e-columns>
      </ejs-grid>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <div class='h-inputLit col-sm-6'>{{this.$t('步骤')}}</div>
          <div class='h-inputLit col-sm-6'>{{this.$t('升级时间')}}</div>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <div class='col-sm-2 h-col-inputBox'>
            <ejs-checkbox label='过滤' ref='filter' :checked='true'></ejs-checkbox>
          </div>
          <div class='col-sm-2 h-col-inputBox'>
            <ejs-checkbox label='推送' ref='push' :checked='false'></ejs-checkbox>
          </div>
          <div class='col-sm-2 h-col-inputBox'>
            <ejs-checkbox label='激活' ref='active' :checked='false'></ejs-checkbox>
          </div>
          <div class='col-sm-6 h-col-inputBox'>
            <ejs-datepicker class='e-input e-disabled e-input-group' :format='dateFormat'
                            v-model='oprTime' :locale='locale'></ejs-datepicker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {CommandColumn} from '@syncfusion/ej2-vue-grids';

  export default {
    name: 'DeviceVersion',
    provide: {
      grid: [CommandColumn]
    },
    data() {
      return {
        commandsAdd: [{buttonOption: {content: '详情', cssClass: 'e-flat'}}],
        commandsDel: [{buttonOption: {content: '删除', cssClass: 'e-flat'}}],
        srcDataSource: [], // neid唯一判别标识符
        desDataSource: [],
        locale: localStorage.getItem('locale'),
        buttonText: '',
        oprTime: '',
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        oprMap: {
          0: '升级',
          1: '回退'
        },
        upOrBack: 0,
      }
    },
    methods: {
      init(param) {
        // 初始参数赋值
        this.oamTypeCode = param['oamTypeCode'];
        this.upOrBack = param['upOrBack'];
        this.srcDataSource = param['dataSource'];
        if (this.upOrBack === 0) {
          this.buttonText = '加入待升级列表';
        } else {
          this.buttonText = '加入待回退列表';
        }
        // this.getList();
      },
      // getList() {
      //
      // },
      srcToDes() {
        const record = this.$refs.srcGrid.ej2Instances.getSelectedRecords();
        this.srcDataSource = this.srcDataSource.filter(item => {
          let neidList = record.map(re => re.neid);
          return !neidList.includes(item.neid);
        });
        this.desDataSource.push(record);
      },
      onClickDel(args) {
        const data = args.rowData;
        console.log('onClickDel');
        console.log(data);
        this.srcDataSource.push(data);
        this.desDataSource = this.desDataSource.filter(item => {
          let neidList = data.map(re => re.neid);
          return !neidList.includes(item.neid);
        });
      },
      onClickLog(args) {
        const data = args.rowData;
        //  详情展示弹窗？
      },
      getData() {
        const deviceList = this.$refs.desGrid.ej2Instances.dataSource;
        let ifFilter = 0;
        let isDownLoad = 0;
        let isActive = 0;
        let isUpLoad = 0;
        if (this.$refs.filter.ej2Instances.checked) {
          ifFilter = 1;
        }
        if (this.$refs.push.ej2Instances.checked) {
          isUpLoad = 1;
        }
        if (this.$refs.active.ej2Instances.checked) {
          isActive = 1;
        }
        const param = {};
        param['deviceList'] = deviceList;
        param['oprObj'] = {
          ifFilter: ifFilter,
          isActive: isActive,
          isUpLoad: isUpLoad
        };
        param['oprTime'] = this.oprTime;
      },
      confirm() {
        this.$layer.confirm({
          msg: this.$t('注意：操作后设备将重启，是否继续？'),
          btn1: {
            msg: this.$t('Common.confirm'),
            func: this.deVeCon
          }
        });
      },
      deVeCon() {
        let url = '';
        if (this.upOrBack === 0) {
          url = '/lte/ems/packageManager/upgradeDevice';
        } else {
          url = '/lte/ems/packageManager/backDevice';
        }
        const param = {};
        this.$axios.post(url, param).then(res => {

        });
      }
    }
  }
</script>

